class enumEdades {
//tamaños_animal: ['MP', 'P', 'M', 'G', 'MG'],
    constructor(){
        this.edadEnum = {
            C : "Cachorro",
            J : "Joven",
            A : "Adulto",
            M : "Mayor",
            AB : "Abuelo"
        };

        this.convertir = this.convertir.bind(this);
    }

    convertir(edad){
        return this.edadEnum[edad]
    }

    revertir(edad) {
        return Object.keys(this.edadEnum).find(key => this.edadEnum[key] === edad);
    }
}

export default enumEdades
